export const environment = { 
  production: true,
  configApiURL: 'https://tymes4-v2-app-prod-api-backoffice.azurewebsites.net/v2/',
  devtunnelEnabled: false,
  devtunnelApiUrl: '',
  messageDuration: 2500,
  templateEditorUrl: 'https://template-editor.tymes4-infra.com' 
}
